var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrab = function SvgGrab(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2h4v4H0zM0 10h4v4H0zM0 18h4v4H0zM0 26h4v4H0zM8 2h4v4H8zM8 10h4v4H8zM8 18h4v4H8zM8 26h4v4H8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrab);
export default ForwardRef;